import { gql } from "@apollo/client";

export const GetItemDetatilsByNodeId = gql`
  query GetItemDetatilsByNodeId($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsStckItemDetails {
        prodSerialNo
        prodLatitude
        prodLongitude
        prodBatchNo
        prodExpiryDate
        prodWarrantyEndDate
        prodInstallationEndDate
        prodWarrantyEndDate
        curCompanyID
        poleNum
        ticketStatus
        item {
          id
          icon
          code
          desc
        }
        vendorDetails {
          desc
        }
        currentSubsidiary {
          name
        }
        currentSite {
          name
        }
        currentCompany {
          name
        }
      }
    }
  }
`;
